module.exports = __webpack_public_path__ + "media/dashboard/assets/images/lock-5b3aa47496905629e62ab4e5075e85f1.svg";